// extracted by mini-css-extract-plugin
export default {"info":"A3_kY","item":"Mg5J2","itemLabel":"cO1_q","itemValue":"rspa4","itemValuePromocode":"j5Etj","itemValueDirect":"JCQ8v"};